function handleErrors(error) {
  if (error) {
    return error.reduce((acc, current) => `${acc}, ${current}`);
  }
  return '';
}

export default handleErrors;
